import { useEffect, useState } from 'react';

type Props = {
  stepNumber: number;
};

// In future when we capture information for secondary vertical,
// this hook will help us iterate the number of steps easily

// Instead of putting all the logic in ProgressFlowNavbar
// We are dividing the logic piece in a separate hook making it easier to understand and test

const useMVEnrollmentSteps = (props: Props) => {
  const [label, setLabel] = useState<string>('');
  const [totalStepsNumber, setTotalStepsNumber] = useState<number>(0);
  const [hideSteps, setHideSteps] = useState<boolean>(false);

  const { stepNumber } = props;

  useEffect(() => {
    if (stepNumber === 0) {
      setLabel('Great!');
      setHideSteps(true);
    } else {
      setLabel('Build your profile:');
      setTotalStepsNumber(3);
    }
  }, [stepNumber]);

  return {
    mvLabel: label,
    mvTotalSteps: totalStepsNumber,
    mvHideSteps: hideSteps,
  };
};

export default useMVEnrollmentSteps;
